// project import
import Other from './other';
import pages from './pages';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const MenuItems = () => {
    const menuItems: { items: NavItemType[] } = {
        //items: [pages, other]
        items: [Other()]
    };
    const location = useLocation();
    useEffect(() => {
        console.log('Location changed');
    }, [location]);

    return menuItems;
};

export default MenuItems;
